import axios from 'axios';
import * as Sentry from '@sentry/browser';
import { APP_ENDPOINT } from 'config';

const apiService = axios.create();

apiService.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response;
  },
  function (error) {
    // No need to capture 401 and 403 errors
    if (error?.response?.status !== 401 && error?.response?.status !== 403) {
      Sentry.captureException(error);
    }

    if (error?.response?.status === 401) {
      window.location.replace(`${APP_ENDPOINT}/login`);
    }

    return Promise.reject(error);
  }
);

export default apiService;
